// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__dD2fR","unreadBadge":"styles_unreadBadge__3j-GS","modalContent":"styles_modalContent__2kus2","modal":"styles_modal__X8GXW"};